import React from 'react';
import Link from 'next/link';
import { Card, Input, Select } from '@avila-tek/ui/src';
import { Currency, PaymentMethod } from '../../../models';
import { FormHeader } from '../../shared/Forms';
import PaymentMethodData from './PaymentMethodData';

interface PaymentMethodFormFields {
  formState: PaymentMethod;
  setFormState: React.Dispatch<React.SetStateAction<Partial<PaymentMethod>>>;
  currencies: Currency[];
}

function PaymentMethodFormFields({
  formState,
  setFormState,
  currencies,
}: PaymentMethodFormFields) {
  const { title, currency, commission } = formState;

  const handleInputChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  return (
    <Card>
      <FormHeader
        href="/app/settings/payment"
        backBtnText="Métodos de pago"
        title={
          formState._id ? 'Actualizar método de pago' : 'Crear método de pago'
        }
      />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-4 ">
          <div className="w-full">
            <Input
              value={title}
              label="Nombre"
              name="title"
              type="text"
              placeholder="Ingrese un nombre"
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="w-full">
            <Select
              name="currency"
              value={(currency as string) ?? ''}
              label="Moneda"
              onChange={handleInputChange}
              required
            >
              <option value="" disabled>
                Seleccione una moneda
              </option>
              {currencies?.map((c) => (
                <option value={c._id}>{c.name}</option>
              ))}
            </Select>
          </div>
        </div>
        <div className="w-full  flex ">
          <div className=" w-1/2 md:pr-2">
            <Input
              value={commission}
              label="Comisión"
              name="commission"
              type="number"
              placeholder="Ingrese el % de la comisión"
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <hr className="mt-2" />
        <PaymentMethodData formState={formState} setFormState={setFormState} />
      </Card.Body>
    </Card>
  );
}

export default PaymentMethodFormFields;
